import { defineComponent as _defineComponent } from 'vue'
import { nextTick, onMounted, ref } from 'vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'Sim-Accordion',
  props: {
    active: { type: Boolean, default: false },
    defaultOpen: { type: Boolean, default: false }
  },
  emits: ['toggle'],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { active: boolean, defaultOpen: boolean };




const accordion = ref<HTMLDetailsElement | null>(null);
const open = ref(false);

async function toggleAccordion() {
	open.value = !open.value;
	await nextTick();

	if (open.value) {
		accordion.value?.scrollIntoView({ behavior: 'smooth' });
	}
	emits('toggle', open.value);
}

function openAccordion() {
	open.value = true;
}

function closeAccordion() {
	open.value = false;
}

onMounted(() => {
	if (props.defaultOpen) {
		openAccordion();
	}
});
expose({
	openAccordion,
	closeAccordion,
});

return { __sfc: true,props, emits, accordion, open, toggleAccordion, openAccordion, closeAccordion, faChevronDown }
}

})